var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 27,
    viewBox: "0 0 76 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30166 23.8473C4.37666 23.9723 0.49666 23.4723 0.37666 20.4723C0.22666 16.7223 0.67666 14.1723 2.32666 13.0473C3.03261 12.5659 4.52218 11.8503 6.13024 11.0778C8.28064 10.0447 10.6429 8.9098 11.6266 8.09724C13.3516 6.67224 19.8016 1.49726 21.4516 0.897261C23.1016 0.297261 69.4516 -0.227739 70.6516 0.522261C71.8516 1.27226 73.7266 10.5722 73.9516 11.9972C74.0319 12.5058 74.0262 13.5207 74.0198 14.6669V14.667V14.6671C74.0082 16.7324 73.9943 19.2238 74.4766 19.9472L74.5448 20.0495C75.258 21.1182 75.7447 21.8475 75.5266 22.6472C75.3239 23.3905 69.3997 24.0728 67.6239 24.146C67.8366 23.5354 67.9521 22.8794 67.9521 22.1964C67.9521 18.9241 65.2994 16.2714 62.0271 16.2714C58.7549 16.2714 56.1021 18.9241 56.1021 22.1964C56.1021 22.8775 56.2171 23.5317 56.4285 24.1407C56.0715 24.1429 55.7354 24.1451 55.4266 24.1472H18.1516L17.6774 24.1352C17.8877 23.5278 18.0019 22.8754 18.0019 22.1964C18.0019 18.9241 15.3492 16.2714 12.0769 16.2714C8.80463 16.2714 6.15192 18.9241 6.15192 22.1964C6.15192 22.7701 6.23345 23.3247 6.38556 23.8494L6.30166 23.8473ZM14.0264 10.2722C16.7514 7.84716 22.4114 2.92216 23.2514 2.62216C24.0914 2.32216 28.4014 2.49716 30.4514 2.62216V9.82219L14.0264 10.2722Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0766,
    cy: 22.1967,
    r: 3.75,
    stroke: "#BABABA",
    strokeWidth: 1.95
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.0766,
    cy: 22.1967,
    r: 3.75,
    stroke: "#BABABA",
    strokeWidth: 1.95
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default ForwardRef;